import clsx from 'clsx'
import Image from 'next/image'

import { FullWidthWrap } from '@/shared/ui/FullWidthWrap'

import { AdvantagesOur } from './advantages-our/advantages-our'
import { advantagesData, bannerDesktop, bannerMobile, faqItems, serviceTodayData } from './data'
import { FollowUs } from './follow-us/follow-us'
import { ServiceFaq } from './service-faq/service-faq'
import { ServiceToday } from './service-today/service-today'
import { SpecialistsOur } from './specialists-our/specialists-our'
import { SummaryLatter } from './summary-latter/summary-latter'
import { SummaryToday } from './summary-today/summary-today'

import cl from './style.module.scss'

export const PromoService = () => {
	return (
		<div className={cl.root}>
			<FullWidthWrap>
				<section className={cl.banner_section}>
					<Image
						src={bannerDesktop.src}
						alt={bannerDesktop.alt}
						width={bannerDesktop.width}
						height={bannerDesktop.height}
						priority={true}
						quality={100}
						className={clsx(cl.banner, cl.banner_desktop)}
					/>
					<Image
						src={bannerMobile.src}
						alt={bannerMobile.alt}
						width={bannerMobile.width}
						height={bannerMobile.height}
						priority={true}
						quality={100}
						className={clsx(cl.banner, cl.banner_mobile)}
					/>
					<div className={cl.wrapper}>
						<h1>
							С&nbsp;заботой о&nbsp;каждом устройстве.<span>Ваш iPort.</span>
						</h1>
						<p>
							Общая миссия нашей группы компаний&nbsp;&mdash; &laquo;За&nbsp;техникой видим людей&raquo;,
							и&nbsp;мы&nbsp;искренне следуем этому принципу. Поэтому наш сервис&nbsp;&mdash; это прежде всего забота
							о&nbsp;людях, через внимание к&nbsp;вашей технике и&nbsp;вашим потребностям. Мы&nbsp;не&nbsp;просто
							ремонтируем устройства&nbsp;&mdash; мы&nbsp;делаем этот процесс как можно более удобным и&nbsp;комфортным
							для вас.
						</p>
					</div>
				</section>
			</FullWidthWrap>

			<section className={cl.summary}>
				<h2>О нашей компании</h2>
				<ul>
					<SummaryLatter />
					<SummaryToday />
				</ul>
			</section>
			<FullWidthWrap>
				<ServiceToday items={serviceTodayData} />
			</FullWidthWrap>
			<FullWidthWrap>
				<AdvantagesOur items={advantagesData} />
			</FullWidthWrap>
			<FullWidthWrap>
				<SpecialistsOur />
			</FullWidthWrap>
			<FullWidthWrap>
				<ServiceFaq faqItems={faqItems} />
			</FullWidthWrap>
			<FullWidthWrap>
				<FollowUs />
			</FullWidthWrap>
		</div>
	)
}
